import { render, staticRenderFns } from "./ReviewBar.vue?vue&type=template&id=01511c26"
import script from "./ReviewBar.vue?vue&type=script&lang=js"
export * from "./ReviewBar.vue?vue&type=script&lang=js"
import style0 from "./ReviewBar.vue?vue&type=style&index=0&id=01511c26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports